import {Store} from 'vuex';

export const state = () => ({});

export const actions = {
    /**
     * Получение конфигурации сайта
     */
    async nuxtServerInit<S = any>(this: any, store: Store<S>, app: any): Promise<void> {
        try {
            const cookieSessionToken = app.$cookies.get('sessionToken');

            const res = await store.dispatch('appState/GET_REQUEST', '/configs', {root: true});

            if (!cookieSessionToken) {
                const cookiesOpt = app.$getCookiesOpt({
                    path: '/',
                    maxAge: 60 * 60 * 24 * 60,
                });
                app.$cookies.set('sessionToken', res.headers['x-session-token'], cookiesOpt);
            }

            store.commit('appState/setConfig', res.data, {root: true});


            // Инициализация JJ
            const currentHost = app?.req?.headers?.host || "";
            const subdomainForJJ = process.env.subdomainForJJ || "";
            const homePageForSubdomainForJJ = process.env.homePageForSubdomainForJJ || "";
            const isJJ = Boolean(currentHost.split(`${subdomainForJJ}.`).length > 1);
            if (!!subdomainForJJ && !!homePageForSubdomainForJJ && isJJ) {
                store.commit('local-settings/setIsJJ', true);
            }

            store.commit('local-settings/setCurrentHost', currentHost);
        } catch (e) {
            console.error('Невозможно получить конфигурацию ', e);
        }
    },
};
